// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bfftypes/v1/trading_time_zone_type.proto (package bfftypes.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bfftypes/v1/trading_time_zone_type.proto.
 */
export const file_bfftypes_v1_trading_time_zone_type: GenFile = /*@__PURE__*/
  fileDesc("CihiZmZ0eXBlcy92MS90cmFkaW5nX3RpbWVfem9uZV90eXBlLnByb3RvEgtiZmZ0eXBlcy52MSrKAQoTVHJhZGluZ1RpbWVab25lVHlwZRImCiJUUkFESU5HX1RJTUVfWk9ORV9UWVBFX1VOU1BFQ0lGSUVEEAASHwobVFJBRElOR19USU1FX1pPTkVfVFlQRV9CQVNFEAESHwobVFJBRElOR19USU1FX1pPTkVfVFlQRV9QRUFLEAISIwofVFJBRElOR19USU1FX1pPTkVfVFlQRV9PRkZfUEVBSxADIgQIBBAEKh5UUkFESU5HX1RJTUVfWk9ORV9UWVBFX1dFRUtFTkRCQlpAZ2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdHlwZXMvdjE7YmZmdHlwZXN2MWIGcHJvdG8z");

/**
 * TradingTimeZoneType classifies the time-of-day pattern of a bilateral
 * electricity trade. Mirrors backend types.v1.TradingTimeZoneType 1:1.
 * Hosted under bfftypes/v1 so that multiple BFF service packages can share
 * this enum without cross-package coupling.
 *
 * @generated from enum bfftypes.v1.TradingTimeZoneType
 */
export enum TradingTimeZoneType {
  /**
   * @generated from enum value: TRADING_TIME_ZONE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ベース (24 時間 × 全日)。
   *
   * @generated from enum value: TRADING_TIME_ZONE_TYPE_BASE = 1;
   */
  BASE = 1,

  /**
   * ピーク (非休日 08:00-20:00、業界標準ピーク帯)。
   *
   * @generated from enum value: TRADING_TIME_ZONE_TYPE_PEAK = 2;
   */
  PEAK = 2,

  /**
   * オフピーク (ピーク補集合: 非休日 00:00-08:00 + 非休日 20:00-24:00 + 休日全時間)。
   *
   * @generated from enum value: TRADING_TIME_ZONE_TYPE_OFF_PEAK = 3;
   */
  OFF_PEAK = 3,
}

/**
 * Describes the enum bfftypes.v1.TradingTimeZoneType.
 */
export const TradingTimeZoneTypeSchema: GenEnum<TradingTimeZoneType> = /*@__PURE__*/
  enumDesc(file_bfftypes_v1_trading_time_zone_type, 0);

